var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C6.0375 7 5.21354 6.65729 4.52813 5.97188C3.84271 5.28646 3.5 4.4625 3.5 3.5C3.5 2.5375 3.84271 1.71354 4.52813 1.02813C5.21354 0.342708 6.0375 0 7 0C7.9625 0 8.78646 0.342708 9.47188 1.02813C10.1573 1.71354 10.5 2.5375 10.5 3.5C10.5 4.4625 10.1573 5.28646 9.47188 5.97188C8.78646 6.65729 7.9625 7 7 7ZM0 12.25V11.55C0 11.0542 0.127604 10.5984 0.382812 10.1828C0.638021 9.76719 0.977083 9.45 1.4 9.23125C2.30417 8.77917 3.22292 8.4401 4.15625 8.21406C5.08958 7.98802 6.0375 7.875 7 7.875C7.9625 7.875 8.91042 7.98802 9.84375 8.21406C10.7771 8.4401 11.6958 8.77917 12.6 9.23125C13.0229 9.45 13.362 9.76719 13.6172 10.1828C13.8724 10.5984 14 11.0542 14 11.55V12.25C14 12.7312 13.8286 13.1432 13.4859 13.4859C13.1432 13.8286 12.7312 14 12.25 14H1.75C1.26875 14 0.856771 13.8286 0.514063 13.4859C0.171354 13.1432 0 12.7312 0 12.25Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.67bcc274adcc9ab432ba5b629333177e.svg";
export { ForwardRef as ReactComponent };